"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SECONDS_IN_MINUTE = exports.MINUTES_IN_HOUR = exports.MILLIS_IN_MINUTE = exports.MILLISECONDS = exports.HOURS_IN_DAY = exports.DAYS_IN_YEAR = void 0;
var DAYS_IN_YEAR = 365;
exports.DAYS_IN_YEAR = DAYS_IN_YEAR;
var HOURS_IN_DAY = 24;
exports.HOURS_IN_DAY = HOURS_IN_DAY;
var MINUTES_IN_HOUR = 60;
exports.MINUTES_IN_HOUR = MINUTES_IN_HOUR;
var SECONDS_IN_MINUTE = 60;
exports.SECONDS_IN_MINUTE = SECONDS_IN_MINUTE;
var MILLISECONDS = 1000;
exports.MILLISECONDS = MILLISECONDS;
var MILLIS_IN_MINUTE = SECONDS_IN_MINUTE * MILLISECONDS;
exports.MILLIS_IN_MINUTE = MILLIS_IN_MINUTE;